module.exports = __webpack_public_path__ + "img/jtupay-playstore.be94075c.png";